import { RouteConfig } from 'vue-router';
const CostAnalysisModule = () =>
  import(/* webpackChunkName: 'costAnalysis' */ './CostAnalysisModule.vue');
const OverviewPage = () =>
  import(/* webpackChunkName: 'costAnalysis' */ './pages/OverviewPage.vue');
const AdvancedAnalysisPage = () =>
  import(
    /* webpackChunkName: 'costAnalysis' */ './pages/AdvancedAnalysisPage.vue'
  );
const QualitativeAnalysisPage = () =>
  import(
    /* webpackChunkName: 'costAnalysis' */ './pages/QualitativeAnalysisPage.vue'
  );
const SummaryPage = () =>
  import(/* webpackChunkName: 'costAnalysis' */ './pages/UserSummaryPage.vue');
import { TARGET_ENTITIES } from '@/utils/constants';

export const CostAnalysisRoutes: RouteConfig[] = [
  {
    path: 'cost-analysis',
    component: CostAnalysisModule,
    props: true,
    meta: {
      middlewares: {
        canAccessEntity: TARGET_ENTITIES.costAnalysis
      }
    },
    children: [
      {
        path: '',
        name: 'costAnalysis',
        component: AdvancedAnalysisPage
      }
    ]
  }
];
